<div class="col" [class.disabled]="disabled">
    <input  (click)="clickHandler()" type="radio" [id]="id" [name]="'applianceOption'" class="hiddenRadio" [disabled]="disabled" [checked]="selected"> 
    <label [for]="id"><div><img [src]="imagePath" /></div>{{label}}</label>
</div>